// extracted by mini-css-extract-plugin
module.exports = {"header":"ConfirmNavigation-module__header___3rghw","body":"ConfirmNavigation-module__body___zIZNW","buttons":"ConfirmNavigation-module__buttons___1S38S"};